import React from "react"
import PropTypes from "prop-types"

const EnvironmentBadge = ({ position = "top-right", className = "" }) => {
    const environment = process.env.REACT_APP_ENVIRONMENT || "development"

    // Don't show badge in production
    if (environment.toLowerCase() === "production") {
        return null
    }

    const getEnvironmentStyles = () => {
        switch (environment.toLowerCase()) {
            case "staging":
                return {
                    backgroundColor: "#f59e0b",
                    color: "#ffffff",
                    label: "STAGING"
                }
            case "development":
                return {
                    backgroundColor: "#10b981",
                    color: "#ffffff",
                    label: "DEVELOPMENT"
                }
            case "uat":
                return {
                    backgroundColor: "#8b5cf6",
                    color: "#ffffff",
                    label: "UAT"
                }
            case "live":
                return {
                    backgroundColor: "#10b981",
                    color: "#ffffff",
                    label: "LIVE"
                }
            default:
                return {
                    backgroundColor: "#6b7280",
                    color: "#ffffff",
                    label: environment.toUpperCase()
                }
        }
    }

    const { backgroundColor, color, label } = getEnvironmentStyles()

    const positionStyles = {
        "top-right": {
            position: "fixed",
            top: "10px",
            right: "10px",
            zIndex: 9999
        },
        "top-left": {
            position: "fixed",
            top: "10px",
            left: "10px",
            zIndex: 9999
        },
        "inline": {
            display: "inline-flex",
            alignItems: "center",
            alignSelf: "center"
        }
    }

    const badgeStyle = {
        ...positionStyles[position],
        backgroundColor,
        color,
        padding: "6px 12px",
        borderRadius: "4px",
        fontWeight: "bold",
        fontSize: "12px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        letterSpacing: "0.5px"
    }

    return (
        <div className={className} style={badgeStyle}>
            {label}
        </div>
    )
}

EnvironmentBadge.propTypes = {
    position: PropTypes.oneOf(["top-right", "top-left", "inline"]),
    className: PropTypes.string
}

export default EnvironmentBadge
